import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { MenuItem, LazyLoadEvent, } from 'primeng/api';
//import {ApplicationClaimTypesService} from '../../services';
import { IGlobalSearchParam, ISearchGlobalFilter } from '../../../shared/models/Global-Search.model';
import { DialogService } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Message } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../../shared/services/shared.service';
//import { ApplicationClaimTypes } from '../../models';

import { Router, ActivatedRoute } from '@angular/router';
import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { Table } from 'primeng/table';
import { ExcelService } from 'src/app/shared/services/excel.service';
import * as fs from 'file-saver';
import * as XLSX from 'xlsx';
import { VendorActivityService } from '../../services';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { IReport } from '../../models/vendor-activity.model';
import { JwtService } from 'src/app/auth/services';

interface vendorReport {
  name: string,
  code: string
}
@Component({
  selector: 'app-vendor-activity',
  templateUrl: './vendor-activity.component.html',
  styleUrls: ['./vendor-activity.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class VendorActivityComponent implements OnInit {
  reportForm: FormGroup;
  isGenerateReportForm: boolean = false;
  isGenerateReportIMG: boolean = true;
  startDate: Date;
  endDate: Date;
  reportTypes: ILookupCategory;
  selectedReportType: vendorReport;
  summaryReport: any;
  detailedReport: any;
  isSummaryReport: boolean = false;
  isDetailedReport: boolean = false;

  SummaryfileName = 'SummaryExcelSheet.xlsx';
  DetailedfileName = 'DetailedExcelSheet.xlsx';
  clientNameList;
  vendorNameList;
  selectedClientIds: string = "";
  selectedVendorIds: string = "";
  categoryName;
  reportTypeId: any;
  reportTypeEnable: boolean = true;
  reportDescription: string;
  splittedClientNamesList = '';
  summaryReportArr;
  isReportTypeSelected: boolean = false;
  isVendorSelected: boolean = false;
  reportTypedropdown: any;
  public selectedReportTypeId: Array<any> = [];
  public selectedClientId: Array<any> = [];
  public selectedVendorId: Array<any> = [];
  minDate: Date;
  maxDate: Date;
  allSummaryGridColumns = [
    { value: 'rank', header: 'Rank' },
    { value: 'vendorName', header: 'Vendor' },
    { value: 'clientName', header: 'Client' },
    { value: 'requisitionCount', header: 'Total Requisitions' },
    { value: 'totalPositionCount', header: 'Total Positions' },
    { value: 'submissionCount', header: 'Total Submissions' },
    { value: 'submissionByDvmsCount', header: 'No. of Submitted Applicants' },
    { value: 'submissionByImportCount', header: 'No. of Imported Applicants' },
    { value: 'submissionRejectionCount', header: 'No. of Rejected Applicants' },
    { value: 'submissionWithdrawnCount', header: 'No. of Submission Withdrawn' },
    { value: 'interviewsCount', header: 'Total Interviews' },
    { value: 'interviewsByDvmsCount', header: 'No. of DVMS Interviews' },
    { value: 'interviewsByImportCount', header: 'No. of Imported Interviews' },
    { value: 'engagementCount', header: 'Total Engagements' },
    { value: 'engagementsByDvmsCount', header: 'No. of DVMS Engagements' },
    { value: 'engagementsByImportCount', header: 'No. of Imported Engagements' },
    { value: 'interviewsWithdrawnCount', header: 'No.of Interviews withdrawn' },
    { value: 'engagementWithdrawnCount', header: 'No.of Engagements withdrawn' },
    { value: 'totalTerminationCount', header: 'No. of Terminations' },
    { value: 'totalProjectsCompletedCount', header: 'No. of Projects Completed' },
    { value: 'candidatesLeftTheJobCount', header: 'No. of Candidates Left The Job' }

  ];

  selectedSummaryGridColumns = [
    { value: 'rank', header: 'Rank' },
    { value: 'vendorName', header: 'Vendor' },
    { value: 'clientName', header: 'Client' },
    { value: 'requisitionCount', header: 'Total Requisitions' },
    { value: 'submissionCount', header: 'Total Submissions' },
    { value: 'submissionByDvmsCount', header: 'No. of Submitted Applicants' },
    { value: 'submissionRejectionCount', header: 'No. of Rejected Applicants' },
    { value: 'interviewsCount', header: 'Total Interviews' },
    { value: 'interviewsByDvmsCount', header: 'No. of DVMS Interviews' },
    { value: 'engagementCount', header: 'Total Engagements' },
    { value: 'engagementsByDvmsCount', header: 'No. of DVMS Engagements' },
    { value: 'interviewsWithdrawnCount', header: 'No.of Interviews withdrawn' },
    { value: 'engagementWithdrawnCount', header: 'No.of Engagements withdrawn' },
    { value: 'totalPositionCount', header: 'Total Positions' },
    { value: 'totalTerminationCount', header: 'No. of Terminations' },
    { value: 'totalProjectsCompletedCount', header: 'No. of Projects Completed' }
  ];

  allDetailedGridColumns = [
    { value: 'rank', header: 'Rank' },
    { value: 'vendorName', header: 'Vendor' },
    { value: 'clientName', header: 'Client' },
    { value: 'intterviewAccepetedApplicants', header: 'Interview Accepted Applicants' },
    { value: 'interviewWithdrawnApplicants', header: 'Interview Withdrawn Applicant' },
    { value: 'engagedApplicants', header: 'Engaged Applicants' },
    { value: 'offerWithdrawnApplicants', header: 'Offer Withdrawn Applicants' }
  ];

  selectedDetailedGridColumns = [
    { value: 'rank', header: 'Rank' },
    { value: 'vendorName', header: 'Vendor' },
    { value: 'clientName', header: 'Client' },
    { value: 'intterviewAccepetedApplicants', header: 'Interview Accepted Applicants' },
    { value: 'interviewWithdrawnApplicants', header: 'Interview Withdrawn Applicant' },
    { value: 'engagedApplicants', header: 'Engaged Applicants' },
    { value: 'offerWithdrawnApplicants', header: 'Offer Withdrawn Applicants' }
  ];
  startDateSelectedDate: Date = new Date();
  @ViewChild('multiSelectVendor') multiSelectVendor: any;
  @ViewChild('multiSelectClient') multiSelectClient: any;
  sortField:string = 'vendorName';
  sortOrder:string = 'desc';
  oldSortField:string = '';
  oldSortOrder:string = 'desc';

  constructor(
    private vendorActivityService: VendorActivityService,
    private sharedService: SharedService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private jwtService: JwtService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.checkViewPermission();
    this.getClientNames();
    this.getVendorNames();
    this.getReportTypes();
    this.reactiveForm();
    this.maxDate = new Date();
    this.startDateSelectedDate = new Date();
  }
  reactiveForm() {
    this.reportForm = this.formBuilder.group({
      startDate: new FormControl(null, [Validators.required]),
      endDate: new FormControl(null, [Validators.required]),
    })
  }
  genReportForm() {
    this.isGenerateReportIMG = false;
    this.isGenerateReportForm = true;

  }

  searchReport({ value }: { value: IReport }) {
    console.log(value);
    // if (value.startDateCon != null) {
    //   var startDateCon = value.startDateCon.toDateString();
    //   let formatedglstartDate = new Date(startDateCon);
    //   formatedglstartDate.setDate(formatedglstartDate.getDate() + 1);
    //   value.startDateCon = (value.startDateCon === null) ? null : formatedglstartDate;
    //   value.startDate =  this.datePipe.transform(value.startDateCon,"yyyy-MM-dd");
    //   console.log(value.startDate);
    // }
    // if (value.endDateCon != null) {
    //   var endDateCon = value.endDateCon.toDateString();
    //   let formatedglendDate = new Date(endDateCon);
    //   formatedglendDate.setDate(formatedglendDate.getDate() + 1);
    //   value.endDateCon = (value.endDateCon === null) ? null : formatedglendDate;
    //   console.log(value.endDateCon);
    //   value.endDate =  this.datePipe.transform(value.endDateCon,"yyyy-MM-dd");
    //   console.log(value.endDate);
    // }
    value.startDate = this.datePipe.transform(value.startDate, "yyyy-MM-dd");
    value.endDate = this.datePipe.transform(value.endDate, "yyyy-MM-dd");
    value.reportType = this.reportTypeId;
    value.clientIds = this.selectedClientIds.toString();
    value.vendorIds = this.selectedVendorIds.toString();
    value.sortField = this.sortField;
    value.sortOrder = this.sortOrder;
    if (this.reportDescription == 'Summary Report') {
      this.spinner.show();
      this.vendorActivityService.generateSummaryReport(value).subscribe((data: any) => {
        this.isSummaryReport = true;
        this.summaryReportArr = undefined;
        this.summaryReportArr = data;
        this.splittedClientNamesList = '';
        for(var i=0;i<data.length;i++)
        {
          this.summaryReportArr[i].clientNamesList=data[i].clientNamesList.toString();
        }
        // for (var i = 0; i < data.length; i++) {
        //   for (var j = 0; j < data[i].clientNamesList.length; j++) {
        //     if (this.splittedClientNamesList == '') {
        //       this.splittedClientNamesList = data[i].clientNamesList[j];
        //     }
        //     else {
        //       this.splittedClientNamesList = this.splittedClientNamesList + ' , ' + data[i].clientNamesList[j];
        //     }

        //   }
        //   //this.splittedClientNamesList =this.splittedClientNamesList.replace(/,/g, '\n');
        //   this.summaryReportArr[i].clientNamesList = this.splittedClientNamesList;
        //   this.splittedClientNamesList = '';
        // }
        this.summaryReport = this.summaryReportArr;
        this.spinner.hide();
      })
    }
    if (this.reportDescription == 'Detailed Report') {
      this.vendorActivityService.generateDetailedReport(value).subscribe((data: any) => {
        this.isDetailedReport = true;
        this.detailedReport = data;
      })
    }
  }


  CancelReportForm() {
    this.reportForm.reset();
    this.selectedReportTypeId = undefined;
    this.selectedClientId = undefined;
    this.selectedVendorId = undefined;
    this.isGenerateReportForm = false;
    this.isGenerateReportIMG = true;
    this.isSummaryReport = false;
    this.isDetailedReport = false;
    this.isReportTypeSelected = false;
    this.isVendorSelected = false;
    this.selectedClientIds = "";
    this.getVendorNames();
    this.getClientNames();
    this.startDateSelectedDate = new Date();
    this.multiSelectVendor.filterValue = '';
    this.multiSelectClient.filterValue = '';


  }

  showAndHideSummaryColumn(event) {
    this.selectedSummaryGridColumns = event.value;
  }
  isShowSummaryColumns(columnName) {
    var tempColumn = this.selectedSummaryGridColumns.filter(col => col.value == columnName);
    if (tempColumn.length == 1) {
      return true;
    }
    return false;
  }

  showAndHideDetailedColumn(event) {
    this.selectedDetailedGridColumns = event.value;
  }
  isShowDetailedColumns(columnName) {
    var tempColumn = this.selectedDetailedGridColumns.filter(col => col.value == columnName);
    if (tempColumn.length == 1) {
      return true;
    }
    return false;
  }

  // exportSummaryReport(): void {
  //   let element = document.getElementById('summary-report');
  //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  //   XLSX.writeFile(wb, this.SummaryfileName);
  // }
  exportSummaryReport ({ value }: { value: IReport }) {
    value.startDate = this.datePipe.transform(value.startDate, "yyyy-MM-dd");
    value.endDate = this.datePipe.transform(value.endDate, "yyyy-MM-dd");
    value.reportType = this.reportTypeId;
    value.clientIds = this.selectedClientIds.toString();
    value.vendorIds = this.selectedVendorIds.toString();
    value.sortField = this.sortField;
    value.sortOrder = this.sortOrder;
    if (this.reportDescription == 'Summary Report') {
      this.spinner.show();
      this.vendorActivityService.exportSummaryReport(value).subscribe(res => {
        var blob = new Blob([res.body], { type: res.body.type });
        const file = new File([blob],"VendorActivityReport.xlsx", { type: res.body.type });
        fs.saveAs(file);
        });
        this.spinner.hide();
    }
  }
  exportDetailedReport(): void {
    let element = document.getElementById('detailed-report');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.DetailedfileName);
  }

  getClientNames() {
    this.vendorActivityService.getClientNames().subscribe((data: any) => {
      this.clientNameList = data;
    });
  }

  getVendorNames() {
    this.vendorActivityService.getVendorNames().subscribe((data: any) => {
      this.vendorNameList = data;
    });
  }
  getClientOnChange(event) {
    this.selectedClientIds = "";
    for (var k = 0; k < event.value.length; k++) {
      if (this.selectedClientIds == "") {
        this.selectedClientIds = event.value[k].companyId;
      }
      else {
        this.selectedClientIds = this.selectedClientIds + ',' + +event.value[k].companyId;
      }
    }
    console.log(this.selectedClientIds);
  }
  getVendorOnChange(event) {

    this.selectedVendorIds = "";
    for (var k = 0; k < event.value.length; k++) {
      if (this.selectedVendorIds == "") {
        this.selectedVendorIds = event.value[k].companyId;
      }
      else {
        this.selectedVendorIds = this.selectedVendorIds + ',' + +event.value[k].companyId;
      }
    }
    if (this.selectedVendorIds == "") {
      this.isVendorSelected = false;
    }
    else {
      this.isVendorSelected = true;
    }
  }
  getReportTypes() {
    this.categoryName = 'Report Type';
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.reportTypes = data;
      this.reportTypes = data.filter(item => item.description !== 'Detailed Report');
    });
  }
  getReportTypeOnChange(event) {
    this.reportTypeId = event.value.lookupOrder;
    this.reportDescription = event.value.description;
    this.isReportTypeSelected = true;
  }

  onSelectStartDate(event) {
    // this.maxDate = new Date(this.datePipe.transform(event, 'yyyy-MM-dd'));
  const localDateString = event.toLocaleDateString('En-en');
  this.startDateSelectedDate = new Date(localDateString);
  var selectedStartDate = new Date(this.startDateSelectedDate);
  this.startDateSelectedDate = selectedStartDate;
  this.reportForm.controls['endDate'].setValue(undefined);
  }

  checkViewPermission() {
    var permission =this.jwtService.getLoggedInUserProfile();
    var allowedUser = this.sharedService.isMspUser();
    if(permission ==0 || allowedUser == false || allowedUser == undefined)
    {
     this.router.navigateByUrl('/login');
    }
  }

loadVendorActivityList(event:LazyLoadEvent){
  this.sortField=event.sortField;
  if(event.sortField === undefined || event.sortField === null)
  {
    this.sortField='';
  }
  if(event.sortOrder === 1)
  {
  this.sortOrder='desc';
  }
  if(event.sortOrder === -1)
  {
  this.sortOrder='asc';
  }
  if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
  {
    this.searchReport(this.reportForm);

  }
  this.oldSortField = this.sortField;
  this.oldSortOrder = this.sortOrder;
}

}
